import { useMemo } from "react";
import { AccountGroup } from "@common/types/domains/accounting/account";
import {
    AccountWithEntity,
    buildCoaAccountTree,
    CoaAccountTreeNode,
    filterCoaAccountTree,
} from "./coaAccountTree";

interface CoaAccountGrouping {
    accountTree: CoaAccountTreeNode[];
    displayedAccountTree: CoaAccountTreeNode[];
}

export function useCoaAccountGrouping({
    accounts,
    groups,
    entityIds,
    search,
}: {
    accounts: AccountWithEntity[] | undefined;
    groups: AccountGroup[] | undefined;
    entityIds?: number[];
    search: string;
}): CoaAccountGrouping {
    const accountTree = useMemo(
        () => buildCoaAccountTree({ accounts, groups, entityIds }),
        [accounts, entityIds, groups],
    );
    const displayedAccountTree = useMemo(
        () => filterCoaAccountTree(accountTree, search),
        [accountTree, search],
    );
    return { accountTree, displayedAccountTree };
}

export type { AccountWithEntity } from "./coaAccountTree";
